import { waitFor } from './private/waitFor.ts';

export { waitFor };
